module.exports = __webpack_public_path__ + "static/media/nar-4.1b59672f.jpg";